// src/views/RewardsView.jsx - CLEAN & FOCUSED
import React from 'react';
import { Wallet, TrendingUp, Award, Zap, Trophy, Target, Rocket } from 'lucide-react';
import { formatBalance } from '../utils/formatters';

export const RewardsView = ({ 
  isConnected, 
  connectWallet, 
  pogeBalance, 
  pendingRewards, 
  stakedTokens, 
  emissionRate,
  userAchievements,
  loading, 
  claim,
  setView,
  nftBalance // This is unstaked NFTs from useContracts
}) => {
  // Total NFTs owned = staked + unstaked
  const totalNFTs = (stakedTokens.length || 0) + (nftBalance || 0);
  
  // Calculate daily earnings
  const dailyEarnings = parseFloat(emissionRate) * stakedTokens.length * 86400;
  
  
  console.log('DEBUG - nftBalance:', nftBalance, 'stakedTokens.length:', stakedTokens.length);
  
  
  
  // Achievements with proper icons
  const achievements = [
    { 
      id: 'early', 
      name: 'Early Adopter', 
      unlocked: userAchievements.isEarlyAdopter,
      desc: 'First 100 stakers',
      icon: Rocket,
      color: 'text-purple-600'
    },
    { 
      id: 'diamond', 
      name: 'Diamond Paws', 
      unlocked: userAchievements.hasDiamondPaws,
      desc: '180+ days staked',
      icon: Trophy,
      color: 'text-blue-600'
    },
    { 
      id: 'collector', 
      name: 'Collector', 
      unlocked: userAchievements.isCollector,
      desc: '10+ NFTs owned',
      icon: Target,
      color: 'text-green-600'
    },
    { 
      id: 'whale', 
      name: 'Poge Whale', 
      unlocked: userAchievements.isPogeWhale,
      desc: 'Major holder',
      icon: Zap,
      color: 'text-yellow-600'
    }
  ];
  
  const unlockedCount = achievements.filter(a => a.unlocked).length;
  
  if (!isConnected) {
    return (
      <div>
        <h2 className="text-3xl md:text-5xl font-black mb-8 text-white uppercase">
          MY $POGE REWARDS
        </h2>
        <div className="text-center py-20 text-xl p-8 bg-gradient-to-br from-black to-gray-900 border-4 border-white/90 shadow-[0_0_20px_rgba(0,255,0,0.2)]">
          <Wallet size={48} className="mx-auto mb-4 opacity-50" />
          <div className="font-bold mb-2">WALLET NOT CONNECTED</div>
          <div className="text-sm opacity-75 mb-4">Connect your wallet to view rewards</div>
          <button 
            onClick={connectWallet}
            className="bg-gradient-to-r from-white to-gray-300 text-black font-bold py-2 px-6 border-2 border-green-400/90 hover:opacity-90 transition-all shadow-[0_0_10px_rgba(0,255,0,0.3)]"
          >
            CONNECT WALLET
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div>
      <h2 className="text-3xl md:text-5xl font-black mb-8 text-white uppercase">
        MY $POGE REWARDS
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        
        {/* CLAIM REWARDS CARD */}
        <div className="bg-gradient-to-br from-green-500 to-green-700 text-white p-6 md:p-8 border-4 border-black shadow-[8px_8px_0_0_#000]">
          <h3 className="text-2xl font-black mb-6 flex items-center gap-2">
            <TrendingUp size={28} />
            CLAIM REWARDS
          </h3>
          
          {/* Pending Rewards - BIG */}
          <div className="mb-6 text-center">
            <div className="text-sm font-bold mb-2 opacity-90">PENDING REWARDS</div>
            <div className="text-6xl md:text-7xl font-black mb-4" style={{ textShadow: '4px 4px 0 #000' }}>
              {parseFloat(pendingRewards).toFixed(2)}
            </div>
            <div className="text-2xl font-bold opacity-90">$POGE</div>
          </div>

          {/* Claim Button */}
          {parseFloat(pendingRewards) > 0 ? (
            <button 
              onClick={claim} 
              disabled={loading}
              className="w-full bg-white text-green-700 font-black text-2xl py-6 border-4 border-black mb-6 disabled:opacity-50 hover:opacity-90 transition-all"
            >
              {loading ? 'CLAIMING...' : '💰 CLAIM NOW'}
            </button>
          ) : stakedTokens.length > 0 ? (
            <div className="w-full bg-black/30 text-white font-bold text-center py-6 border-4 border-black/50 mb-6">
              ⏳ REWARDS ACCUMULATING...
            </div>
          ) : (
            <button
              onClick={() => setView('stake')}
              className="w-full bg-yellow-400 text-black font-black text-xl py-6 border-4 border-black mb-6 hover:opacity-90 transition-all"
            >
              🚀 START EARNING
            </button>
          )}

          {/* Quick Stats */}
          <div className="space-y-3">
            <div className="flex justify-between p-3 bg-black/30 border-2 border-white/50">
              <span className="font-bold">YOUR BALANCE:</span>
              <span className="text-xl font-black">{formatBalance(pogeBalance)}</span>
            </div>
            <div className="flex justify-between p-3 bg-black/30 border-2 border-white/50">
              <span className="font-bold">DAILY RATE:</span>
              <span className="text-xl font-black text-yellow-300">+{dailyEarnings.toFixed(2)}</span>
            </div>
            <div className="flex justify-between p-3 bg-black/30 border-2 border-white/50">
              <span className="font-bold">EARNING NFTs:</span>
              <span className="text-xl font-black">{stakedTokens.length}/{totalNFTs}</span>
            </div>
          </div>

          {/* Manage Button */}
          <button 
            onClick={() => setView('stake')}
            className="w-full mt-6 bg-black text-white font-bold py-3 border-2 border-white hover:bg-gray-900 transition-all"
          >
            ⚡ MANAGE STAKING
          </button>
        </div>
        
        {/* ACHIEVEMENTS CARD */}
        <div className="bg-white text-black p-6 md:p-8 border-4 border-black shadow-[8px_8px_0_0_#000]">
          <h3 className="text-2xl font-black mb-6 flex items-center gap-2">
            <Award size={28} />
            ACHIEVEMENTS
          </h3>

          {/* Progress */}
          <div className="mb-6 p-4 bg-gradient-to-r from-purple-100 to-blue-100 border-2 border-black">
            <div className="flex justify-between items-center mb-2">
              <span className="font-bold text-sm">PROGRESS</span>
              <span className="font-black text-lg">{unlockedCount}/4</span>
            </div>
            <div className="h-4 bg-gray-300 border-2 border-black">
              <div 
                className="h-full bg-gradient-to-r from-purple-500 to-blue-500 transition-all duration-500"
                style={{ width: `${(unlockedCount / 4) * 100}%` }}
              />
            </div>
          </div>

          {/* Achievement Grid */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            {achievements.map((achievement) => {
              const Icon = achievement.icon;
              return (
                <div 
                  key={achievement.id}
                  className={`p-4 border-4 transition-all duration-200 ${
                    achievement.unlocked 
                      ? 'bg-gradient-to-br from-yellow-100 to-yellow-200 border-black hover:scale-105' 
                      : 'bg-gray-200 border-gray-400 opacity-60'
                  }`}
                >
                  <div className="flex justify-center mb-2">
                    <Icon 
                      size={32} 
                      className={achievement.unlocked ? achievement.color : 'text-gray-400'}
                    />
                  </div>
                  <div className="font-black text-xs text-center mb-1">{achievement.name}</div>
                  <div className="text-xs text-center opacity-75">{achievement.desc}</div>
                  <div className="text-center mt-2">
                    {achievement.unlocked ? (
                      <span className="text-green-600 font-black text-sm">✓ UNLOCKED</span>
                    ) : (
                      <span className="text-gray-400 font-bold text-xs">LOCKED</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Stats */}
          <div className="space-y-3">
            <div className="p-3 bg-gray-100 border-2 border-black">
              <div className="flex justify-between items-center">
                <span className="font-bold text-sm">TOTAL COLLECTION:</span>
                <span className="text-xl font-black">{totalNFTs}</span>
              </div>
            </div>
            <div className="p-3 bg-gray-100 border-2 border-black">
              <div className="flex justify-between items-center">
                <span className="font-bold text-sm">PEAK STAKED:</span>
                <span className="text-xl font-black text-purple-600">
                  {userAchievements.peakConcurrentStakes || 0}
                </span>
              </div>
            </div>
            <div className="p-3 bg-gray-100 border-2 border-black">
              <div className="flex justify-between items-center">
                <span className="font-bold text-sm">LIFETIME EARNED:</span>
                <span className="text-xl font-black text-green-600">
                  {formatBalance(userAchievements.totalEarnedPoge || '0')}
                </span>
              </div>
            </div>
          </div>

          {/* Encouragement */}
          {unlockedCount < 4 && totalNFTs > 0 && (
            <div className="mt-6 p-4 bg-yellow-100 border-2 border-yellow-400 text-center">
              <div className="font-black text-sm mb-1">
                {unlockedCount === 0 ? '🎯 START YOUR JOURNEY' : `🔥 ${4 - unlockedCount} MORE TO GO`}
              </div>
              <div className="text-xs opacity-75">
                {unlockedCount === 0 
                  ? 'Unlock achievements by staking and holding' 
                  : 'Keep staking to unlock more achievements'
                }
              </div>
            </div>
          )}

          {unlockedCount === 4 && (
            <div className="mt-6 p-4 bg-gradient-to-r from-purple-500 to-blue-500 text-white border-2 border-black text-center">
              <div className="font-black text-lg mb-1">🏆 LEGEND STATUS</div>
              <div className="text-sm opacity-90">All achievements unlocked!</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};